export const ASSET_MANIFEST = {
  generatedFloor: '/assets/generated/battlefield-floor-gpt-image-2.png',
  environmentAtlas: '/assets/generated/environment-atlas-v2-gpt-image-2.png',
  terrainAtlas: '/assets/generated/terrain-atlas-gpt-image-2.png',
  tankAtlas: '/assets/generated/tank-atlas-normalized.png',
  bossSiegeAtlas: '/assets/generated/boss-siege-atlas-normalized.png',
  bossHunterAtlas: '/assets/generated/boss-hunter-atlas-normalized.png',
  bossBulwarkAtlas: '/assets/generated/boss-bulwark-atlas-normalized.png',
  bossSniperAtlas: '/assets/generated/boss-sniper-atlas-normalized.png',
  heavyTankAtlas: '/assets/generated/heavy-tank-atlas-v2-normalized.png',
  sniperTankAtlas: '/assets/generated/sniper-tank-atlas-normalized.png',
  playerUpgradeAtlas: '/assets/generated/player-upgrade-atlas-normalized.png',
  player2UpgradeAtlas: '/assets/generated/player2-upgrade-atlas-normalized.png',
  playerAssaultClassAtlas: '/assets/generated/player-assault-class-atlas.png',
  playerHeavyClassAtlas: '/assets/generated/player-heavy-class-atlas.png',
  player2AssaultClassAtlas: '/assets/generated/player2-assault-class-atlas.png',
  player2HeavyClassAtlas: '/assets/generated/player2-heavy-class-atlas.png',
  powerupAtlas: '/assets/generated/powerup-atlas-gpt-image-2.png',
  powerupExtraAtlas: '/assets/generated/powerup-extra-atlas-gpt-image-2.png',
  terrainDetailDecals: '/assets/generated/terrain-detail-decals-gpt-image-2.png',
  generatedWith: 'gpt-image-2 / Images 2.0',
  generatedPrompt:
    'High-definition pixel military style battlefield floor, terrain tile atlas, and top-down tank sprite atlas for a modernized classic Battle City browser game.',
} as const;
